<template>
  <div class="fb-patient-allergies">
    <div
      class="mb-0"
      v-if="showType == 'form-builder'"
      :style="properties.style"
    >
      <div class="d-flex justify-content-between bg-light-gray p-3">
        <h5 v-html-sanitize="properties.label"></h5>
        <b-button variant="primary" class="mr-2">
          <i class="fa fa-sync-alt mr-2"></i> Reload Patient Allergies
        </b-button>
      </div>
      <b-table
        striped
        responsive
        hover
        :items="[
          {
            allergyType: 'Allergy type 1',
            allergen: 'Allergen 1',
            reaction: 'Reaction 1',
            severity: 'Severity 1'
          },
          {
            allergyType: 'Allergy type 2',
            allergen: 'Allergen 2',
            reaction: 'Reaction 2',
            severity: 'Severity 2'
          }
        ]"
        :fields="fields"
      ></b-table>
    </div>
    <div v-if="showType == 'properties'">
      <patient-allergies-v1-properties :formId="formId" />
    </div>
    <div 
      v-show="!computedHidden"
      v-if="(showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)" :style="properties.style"
    >
      <div
        class="d-flex justify-content-between align-items-center bg-extra-light-gray px-3 py-2"
      >
        <div style="font-size:16px;" class="mb-0" v-html-sanitize="properties.label"></div>
        <b-button
          size="sm"
          variant="primary"
          class="mr-2"
          @click="reloadPatientAllergies"
          ><i class="fa fa-sync-alt mr-2"></i> Reload Patient
          Allergies</b-button
        >
      </div>
      <b-table style="font-size:14px;" striped responsive hover :items="controlValue" :fields="fields"> </b-table>
    </div>
    <div v-if="showType == 'form-viewer'" :style="properties.style">
      <div
        class="d-flex justify-content-between align-items-center bg-extra-light-gray px-3 py-2"
      >
        <h5 class="mb-0" v-html-sanitize="properties.label"></h5>
      </div>
      <b-table striped responsive hover :items="controlValue" :fields="fields"> </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import PatientAllergiesV1Properties from "./PatientAllergiesV1Properties";
import allergyServer from "../../../../server/allergy";
export default {
  name: "PatientAllergiesV1",
  components: { PatientAllergiesV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "results", "page", "componentsIdSuffix"],
  data() {
    return {
      initialCodes: [],
      computedProperties: ["hidden"],
      computedConditions: {},
    };
  },
  async mounted() {
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      const allergies = await allergyServer.query(this.client.id);

      this.initialCodes = allergies.map(a => ({
        allergyType: a.allergyType?.name,
        allergen: a.otherAllergen ? a.otherAllergen : a.allergen?.name,
        reaction: a.otherReaction ? a.otherReaction : a.reaction?.name,
        severity: a.severity?.name,
        allergyId: a.id
      }));
      this.controlValue = this.initialCodes;
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }
    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    async reloadPatientAllergies() {
      const allergies = await allergyServer.query(this.client.id);
      this.initialCodes = allergies.map(a => ({
        allergyType: a.allergyType?.name,
        allergen: a.otherAllergen ? a.otherAllergen : a.allergen?.name,
        reaction: a.otherReaction ? a.otherReaction : a.reaction?.name,
        severity: a.severity?.name,
        allergyId: a.id
      }));
      this.controlValue = this.initialCodes;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <div>
        <div class="d-flex justify-content-between align-items-center bg-extra-light-gray px-3 py-2">
          <div style="font-size:16px;" class="mb-0">${this.getComponentComputedProperties("label")}</div>
        </div>
        <table role="table" aria-busy="false" aria-colcount="4" class="table b-table table-striped table-responsive table-hover">
          <thead role="rowgroup" class="">
            <tr role="row" class="">
              <th role="columnheader" scope="col" aria-colindex="1" class="">
                <div style="font-size:14px;">Allergy type</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="2" class="">
                <div style="font-size:14px;">Allergen</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="3" class="">
                <div style="font-size:14px;">Reaction</div>
              </th>
              <th role="columnheader" scope="col" aria-colindex="4" class="">
                <div style="font-size:14px;">Severity</div>
              </th>
            </tr>
          </thead>
          <tbody role="rowgroup">
            ${(this.controlValue || [])
              .map(
                item => `
              <tr role="row" class="">
                <td style="font-size:14px;" aria-colindex="1" role="cell" class="">${item.allergyType}</td>
                <td style="font-size:14px;" aria-colindex="2" role="cell" class="">${item.allergen}</td>
                <td style="font-size:14px;" aria-colindex="3" role="cell" class="">${item.reaction ? item.reaction : "" }</td>
                <td style="font-size:14px;" aria-colindex="4" role="cell" class="">${item.severity ? item.severity : ""}</td>
              </tr>
            `
              )
              .join("")}
            
          </tbody>
        </table>
      </div>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      client: state => state.form.client,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    fields() {
      return [
        { key: "allergyType", label: "Allergy type", sortable: false },
        { key: "allergen", label: "Allergen", sortable: false },
        { key: "reaction", label: "Reaction", sortable: false },
        { key: "severity", label: "Severity", sortable: false }
      ];
    },
    controlValue: {
      get() {
        return this.results
          ? this.results[this.id]
          : this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style>
.fb-patient-allergies .table.without-thead td {
  font-size: 14px;
}
</style>
